var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-wrapper" },
    [
      _c("p", { staticClass: "title arrange" }, [
        _vm._v("近期课程"),
        _c(
          "span",
          { staticClass: "class_table", on: { click: _vm.gocalendar } },
          [
            _vm._v("查看课表"),
            _c("i", { staticClass: "updown el-icon-arrow-right" })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "class_calendar" },
        [_c("loop", { attrs: { isLoadCander: _vm.isLoadCander } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "learning_record" }, [
        _c("p", { staticClass: "record_tip" }, [
          _c(
            "span",
            {
              staticClass: "go_on",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.go_on(_vm.lastname)
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../../static/images/goon.png"),
                  alt: ""
                }
              }),
              _vm._v("继续播放")
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "lastname" }, [
            _vm._v(_vm._s(_vm.lastname.unit_name))
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "record_enter", on: { click: _vm.gorecord } },
            [
              _vm._v("学习记录"),
              _c("i", { staticClass: "updown el-icon-arrow-right" })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.member.isMember == 2
        ? _c("div", { staticClass: "member_advertising" }, [
            _c("div", { staticClass: "member_tip" }, [
              _c("p", { staticClass: "member_title" }, [
                _c("img", {
                  attrs: { src: require("../../../static/images/vip.png") }
                }),
                _vm._v("中公优职会员\n        "),
                _vm.member.isForever == 1
                  ? _c("span", { staticClass: "use_time" }, [
                      _vm._v("会员终身有效")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.member.memberEndTime
                  ? _c("span", { staticClass: "use_time" }, [
                      _vm._v(
                        _vm._s(_vm.member.memberEndTime.replace(/-/g, ".")) +
                          "到期"
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.member.memberGoodsRights
                ? _c("p", { staticClass: "member_zx" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/vipkf.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getWxQr(_vm.member.memberGoodsRights)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            JSON.parse(_vm.member.memberGoodsRights[0].detail)
                              .label
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "vip_index" }, [
                      _vm._v(
                        _vm._s(
                          JSON.parse(_vm.member.memberGoodsRights[0].detail)
                            .badge
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.member.memberGoodsRights
                ? _c("p", { staticClass: "member_zx" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/vipwx.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: JSON.parse(
                            _vm.member.memberGoodsRights[1].detail
                          ).services.url
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            JSON.parse(_vm.member.memberGoodsRights[1].detail)
                              .label
                          )
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "title", staticStyle: { "margin-top": "20px" } }, [
        _vm._v("我的课程")
      ]),
      _vm._v(" "),
      _c(
        "van-list",
        {
          attrs: {
            finished: _vm.finished,
            "finished-text": _vm.finishedText,
            offset: 10
          }
        },
        _vm._l(_vm.list, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "item",
              on: {
                click: function($event) {
                  return _vm.getDetail(item.expired_flag, item.system_order_num)
                }
              }
            },
            [
              _c("p", { staticClass: "tit" }, [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c(
                "div",
                { class: [{ tags: item.sell_point != "" }, "tags_both"] },
                _vm._l(item.sell_point, function(dat, id) {
                  return item.sell_point != ""
                    ? _c("span", { key: id }, [
                        _vm._v("\n          " + _vm._s(dat) + "\n        ")
                      ])
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "expires-time" }, [
                item.class_data
                  ? _c("span", { staticClass: "description" }, [
                      _vm._v(_vm._s(item.class_data) + " | "),
                      item.hour
                        ? _c(
                            "span",
                            { class: [{ data_hour: item.class_data }] },
                            [_vm._v(_vm._s(item.hour))]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "expires" }, [
                _vm._v(_vm._s(item.expires))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "teach-box" }, [
                _c(
                  "div",
                  { staticClass: "teachers van-clearfix" },
                  _vm._l(item.teachers, function(data, idx) {
                    return idx < 4
                      ? _c("div", { key: idx }, [
                          _c("img", {
                            attrs: { src: data.head_image, alt: "" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "teachers_name" }, [
                            _vm._v(_vm._s(data.username))
                          ])
                        ])
                      : _vm._e()
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "seeding-time" }, [
                  _c("p", { staticClass: "go-study" }, [
                    _vm._v(_vm._s(item.expired_flag == 0 ? "已过期" : "去学习"))
                  ]),
                  _vm._v(" "),
                  _c("p", { class: ["detail", { mt: item.live_time != "" }] }, [
                    _vm._v(_vm._s(item.live_time))
                  ])
                ])
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.isMember
        ? _c("div", { staticClass: "member-wrapper" }, [
            _c("div", { staticClass: "member-content" }, [
              _c("p", { staticClass: "kf_title" }, [
                _vm._v("微信客服"),
                _c("img", {
                  attrs: { src: require("../../../static/images/cancel.png") },
                  on: {
                    click: function($event) {
                      _vm.isMember = false
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("img", {
                staticClass: "member_img",
                attrs: { src: _vm.wxQrcode }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("使用微信扫码添加")])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "kf_content" }, [
      _vm._v("务必添加专属客户经理，"),
      _c("br"),
      _vm._v("以保证享受会员服务")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-826af616", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-826af616","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/index.vue
// module id = null
// module chunks = 